import React, { Fragment } from 'react'

import Tooltip from '../tooltip/Tooltip'
import { translate } from '../../utils/translation'

import { BoxMessageContent } from './Boxes'
import {
  TooltipContainer,
  Wrapper,
  TitleWrapper,
  Subtitle,
  BoxContent,
  LeftSide,
  CardInformation,
  ValueAndEvaluation,
  Divider,
  RightSide,
} from './styles'

const TitleWithTooltip = ({ title, description, tooltipPosition = 'top' }) => (
  <TooltipContainer>
    {title.toUpperCase()}

    {description && (
      <Tooltip
        id={title}
        text={description}
        place={tooltipPosition}
        style={{ marginLeft: '10px' }}
      />
    )}
  </TooltipContainer>
)

const MultiInfoBox = ({
  title,
  subtitle,
  description,
  leftSideInformation,
  rightSideContent,
}) => {
  return (
    <Wrapper>
      <TitleWrapper>
        <TitleWithTooltip title={title} description={description} />
        <Subtitle>{subtitle}</Subtitle>
      </TitleWrapper>
      <BoxContent>
        <LeftSide>
          {leftSideInformation.map(
            (
              {
                title: itemTitle,
                value,
                description: itemDescription,
                evaluation,
              },
              index,
            ) => (
              <Fragment key={itemTitle}>
                <CardInformation>
                  <TitleWithTooltip
                    title={itemTitle}
                    description={itemDescription}
                  />
                  <ValueAndEvaluation>
                    {value}
                    {evaluation && (
                      <BoxMessageContent
                        data-testid="box-message"
                        bgColor={evaluation.bgColor}
                        borderColor={evaluation.borderColor}
                        mobileMargin="0"
                        customStyles={{
                          margin: '0',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          marginLeft: '16px',
                        }}
                      >
                        {translate(evaluation.tag).toUpperCase()}
                      </BoxMessageContent>
                    )}
                  </ValueAndEvaluation>
                </CardInformation>
                {index < leftSideInformation.length - 1 && <Divider />}
              </Fragment>
            ),
          )}
        </LeftSide>
        <Divider vertical />
        <RightSide>{rightSideContent}</RightSide>
      </BoxContent>
    </Wrapper>
  )
}

export default MultiInfoBox
